module.exports = __webpack_public_path__ + "static/img/ban03.97a552b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/ban03.jpg
// module id = jFGh
// module chunks = 76